<template>
  <div>
    <app-table :id="linksTable" :options="options" @action="getListAction" />
    <app-link-modal
      v-if="isModalActive"
      :tableId="linksTable"
      :selected-url="crudUrl"
      :services="services"
      @close-modal="closeModal"
    />
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="link-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import { urlGenerator } from "../../../../Helpers/AxiosHelper";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { LINKS, SERVICES_NAMES } from "../../../../Config/ApiUrl";

export default {
  name: "Links",
  mixins: [FormMixin],
  props: ["id"],
  data() {
    return {
      services: [],
      urlGenerator,
      crudUrl: undefined,
      isModalActive: false,
      confirmationModalActive: false,
      linksTable: "links-table",
      options: {
        tableShadow: false,
        tablePaddingClass: "px-0 py-primary",
        name: "CustomTable",
        responsive: true,
        url: LINKS,
        showHeader: true,
        columns: [
          {
            title: this.$t("link"),
            type: "custom-html",
            key: "link",
            modifier: (value, row) => {
              return `<span id="${row.id}" style="
              display: inline-block;
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
              ">${window.settings.common_url}${value}</span>`;
            },
          },
          {
            title: this.$t("services"),
            key: "services",
            type: "custom-html",
            modifier: (value) => {
              let output = "";

              value.forEach((service, index) => {
                if (index < value.length - 1)
                  output += `<span>${service.name},</span>&nbsp;&nbsp;`;
                else output += `<span>${service.name}`;
              });
              return output;
            },
          },
          {
            title: "Action",
            type: "action",
          },
        ],
        filters: [],
        showSearch: true,
        showFilter: true,
        showManageColumn: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
        actions: [
          {
            title: "Edit",
            icon: "edit",
            type: "edit",
            component: "app-link-modal",
            modalId: "link-modal",
            url: `${LINKS}/show`,
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "delete",
            component: "app-confirmation-modal",
            modalId: "link-delete-modal",
            url: `${LINKS}/destroy`,
          },
          {
            title: this.$t("copy"),
            icon: "copy",
            type: "copy",
          },
        ],
      },
    };
  },
  methods: {
    copyToClipboard(textToCopy) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(textToCopy);
      } else {
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    getListAction(row, action) {
      this.crudUrl = `${LINKS}/${row.id}`;

      if (action.title == "Delete") {
        this.confirmationModalActive = true;
      } else if (action.title == this.$t("edit")) {
        this.isModalActive = true;
      } else if (action.title == this.$t("copy")) {
        this.copyToClipboard(`${window.settings.common_url}${row.link}`).then(
          () => this.$toastr.s("Copied !")
        );
      }
    },
    confirmed() {
      this.axiosDelete(this.crudUrl)
        .then((response) => {
          $("#link-delete-modal").modal("hide");
          this.$toastr.s(response.data.message);
          this.$hub.$emit("reload-" + this.linksTable);
        })
        .catch(() => {
          this.$toastr.e(response.data.message);
        });
    },
    cancelled() {
      this.confirmationModalActive = false;
    },
    openModal() {
      this.isModalActive = true;
      $("#link-modal").modal("show");
    },
    closeModal() {
      this.isModalActive = false;
      this.crudUrl = undefined;
      $("#link-modal").modal("hide");
    },
  },
  async mounted() {
    this.$hub.$on("headerButtonClicked-" + this.id, () => {
      this.isModalActive = true;
      this.crudUrl = undefined;
    });
    try {
      const res = await axios.get(SERVICES_NAMES);
      console.log(res)
      let services = res.data.map((service) => ({
        id: service.id,
        name: service.name,
        value: service.id,
      }));
      console.log(services)
      this.services = [...new Map(services.map((v) => [v.id, v])).values()];
      console.log(this.services)
    } catch (error) {
      //
      console.log(error)
    }
  },
};
</script>
